import styled from "styled-components";

export const Card = styled.div`
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 30px 40px;
  box-shadow: -2px -2px 4px 0px rgb(242, 242, 242),
    2px 2px 6px 0px rgba(0, 0, 0, 0.352);
  min-height: 100%;
`;

export const OrderCard = styled.div`
  /* background-color: #e4eff3; */
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 30px 40px;
  box-shadow: -2px -2px 4px 0px rgb(255, 255, 255),
    2px 2px 6px 0px rgba(0, 0, 0, 0.352);
  min-height: 100%;
`;
